var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info btn_right",
            attrs: { id: "backBtn", type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v("キャンセルする")]
        ),
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-danger btn_right",
            attrs: { id: "destroyBtn", type: "button" },
            on: { click: _vm.destroy },
          },
          [_vm._v("削除する")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-8" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.modify.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(1),
                _c("div", { staticClass: "col-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.func.functionCode,
                        expression: "func.functionCode",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "20",
                      autocomplete: "off",
                      placeholder: [[_vm.functionDisplayHolder]],
                      required: "",
                    },
                    domProps: { value: _vm.func.functionCode },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.func, "functionCode", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(2),
                _c("div", { staticClass: "col-9" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.func.functionPolicy,
                        expression: "func.functionPolicy",
                      },
                    ],
                    staticClass: "textarea",
                    attrs: { id: "limited", rows: "3", cols: "60" },
                    domProps: { value: _vm.func.functionPolicy },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.func,
                          "functionPolicy",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-3" }),
                _c("div", { staticClass: "col-9" }, [
                  _vm.isFunctionPolicyJson
                    ? _c("label", { staticStyle: { color: "green" } }, [
                        _vm._v("Valid JSON"),
                      ])
                    : _c("label", { staticStyle: { color: "red" } }, [
                        _vm._v("Invalid JSON"),
                      ]),
                ]),
              ]),
            ]),
            _c(
              "button",
              {
                staticClass: "btn btn-info btn btn-block",
                attrs: { id: "modify_button", type: "submit" },
              },
              [_vm._v("更新する")]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-5" }, [_c("h5", [_vm._v("機能編集")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [_c("label", [_vm._v("名称")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("機能ポリシー")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }